export default __webpack_public_path__ + "static/media/apng-maker.04c100fa.png";